import { getIconData } from '@iconify/utils/lib/icon-set/get-icon';
import { offlineIconCollections } from './offline-icons.generated';

interface OfflineIconData {
  body: string;
  left?: number;
  top?: number;
  width?: number;
  height?: number;
  rotate?: number;
  hFlip?: boolean;
  vFlip?: boolean;
}

const offlineIconsByPrefix = new Map<string, (typeof offlineIconCollections)[number]>();

function registerOfflineIconCollections() {
  offlineIconCollections.forEach(collection => {
    offlineIconsByPrefix.set(collection.prefix, collection);
  });
}

function parseOfflineIconName(iconName: string) {
  const normalizedIconName = iconName.trim();
  const separatorIndex = normalizedIconName.includes(':')
    ? normalizedIconName.indexOf(':')
    : normalizedIconName.indexOf('-');

  if (separatorIndex <= 0 || separatorIndex >= normalizedIconName.length - 1) {
    return null;
  }

  return {
    prefix: normalizedIconName.slice(0, separatorIndex),
    name: normalizedIconName.slice(separatorIndex + 1)
  };
}

/** Setup Iconify collections for offline-only rendering. */
export function setupIconifyOffline() {
  registerOfflineIconCollections();
}

export function getOfflineIcon(iconName: string): OfflineIconData | null {
  if (!offlineIconsByPrefix.size) {
    registerOfflineIconCollections();
  }

  const parsedIconName = parseOfflineIconName(iconName);
  if (!parsedIconName) {
    return null;
  }

  const collection = offlineIconsByPrefix.get(parsedIconName.prefix);
  if (!collection) {
    return null;
  }

  return getIconData(collection as any, parsedIconName.name);
}
